import React, { useRef, useState } from 'react';
import { LuArrowLeft, LuArrowRight, LuCheck, LuCloud, LuMusic2, LuPlay } from 'react-icons/lu';
import '../styles/FeatureCarousel.css';

const CATEGORY = ['ANALYZE', 'LISTEN', 'ORGANIZE', 'COMPOSE'];

function FeatureVisual({ index, locale }) {
  const ja = locale === 'ja';
  return (
    <div className={`feature-visual feature-visual--${index}`} aria-hidden="true">
      {index === 0 && <div className="feature-analysis">
        <div className="feature-demo-caption">KEY : C</div>
        <div className="feature-analysis-chords">{[['I','CM7'],['VI','Am7'],['IV','FM7'],['V','G7']].map(([degree,chord],i)=><div className={`feature-analysis-note note-${i}`} key={chord}><span>{degree}</span><strong>{chord}</strong></div>)}</div>
        <div className="feature-demo-result"><LuCheck /> {ja ? 'コードの役割が、ひと目でわかる' : 'See the role of every chord'}</div>
      </div>}
      {index === 1 && <div className="feature-piano">
        <div className="feature-piano-heading"><span className="feature-demo-play"><LuPlay /></span><strong>CM7</strong><span>120 BPM</span></div>
        <div className="feature-piano-keys">{['C','D','E','F','G','A','B'].map((note,i)=><div key={note} className={`feature-white-key${[0,2,4,6].includes(i)?' is-lit':''}`}><span>{note}</span>{[0,1,3,4,5].includes(i)&&<i className="feature-black-key" />}</div>)}</div>
      </div>}
      {index === 2 && <div className="feature-library-demo">
        <span className="feature-demo-cloud"><LuCloud /><LuCheck /></span>
        <div className="feature-saved-scores">{[ja?'春のメロディ':'Spring melody',ja?'夜のスケッチ':'Night sketch'].map((name,i)=><div className="feature-saved-score" key={name}><LuMusic2 /><div><strong>{name}</strong><small>{i ? '#demo' : (ja?'#作曲 #練習':'#compose #practice')}</small></div><LuCheck /></div>)}</div>
      </div>}
      {index === 3 && <div className="feature-sheet-demo">
        <div className="feature-demo-caption">{ja?'浮かんだ進行を、そのまま入力':'Turn an idea into a progression'}</div>
        <div className="feature-sheet-cells">{['C','Am','F','G','','','',''].map((chord,i)=><span className={i===3?'is-selected':''} key={i}>{chord}{i===3&&<i />}</span>)}</div>
        <div className="feature-demo-shortcuts"><kbd>Tab</kbd><kbd>←</kbd><kbd>↑</kbd><kbd>↓</kbd><kbd>→</kbd></div>
      </div>}
    </div>
  );
}

export default function FeatureCarousel({ items, locale }) {
  const [index, setIndex] = useState(0);
  const start = useRef(null);
  const ja = locale === 'ja';
  const go = (next) => setIndex((next + items.length) % items.length);
  const item = items[index];
  const labels = ja ? { previous:'前の機能', next:'次の機能', label:'機能一覧', swipe:'スワイプで切り替え' } : { previous:'Previous feature', next:'Next feature', label:'Features', swipe:'Swipe to explore' };
  return (
    <div className="feature-carousel" role="region" aria-roledescription={ja?'カルーセル':'carousel'} aria-label={labels.label}
      onKeyDown={(event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }}>
      <div className="feature-board">
        <div className="feature-board-top" aria-hidden="true" />
        <div className="feature-board-inner">
          <div className="feature-board-meta"><span>{CATEGORY[index]}</span><span>{item.number} / {String(items.length).padStart(2,'0')}</span></div>
          <div className="feature-slide-gesture" aria-live="polite" aria-atomic="true" onPointerDown={(event) => { if (event.pointerType !== 'mouse' || event.button === 0) { start.current = { x:event.clientX, y:event.clientY }; event.currentTarget.setPointerCapture?.(event.pointerId); } }}
            onPointerUp={(event) => { const first = start.current; start.current = null; if (!first) return; const dx=event.clientX-first.x; const dy=event.clientY-first.y; if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) go(index+(dx<0?1:-1)); }}
            onPointerCancel={() => { start.current=null; }}>
            <article className="feature-slide" key={index}>
              <h4>{item.title}</h4>
              <FeatureVisual index={index} locale={locale} />
              <p className="feature-slide-description">{item.description}</p>
            </article>
          </div>
          <div className="feature-board-controls">
            <button type="button" onClick={() => go(index-1)} aria-label={labels.previous}><LuArrowLeft /></button>
            <span>{labels.swipe}<LuArrowRight aria-hidden="true" /></span>
            <button type="button" onClick={() => go(index+1)} aria-label={labels.next}><LuArrowRight /></button>
          </div>
        </div>
      </div>
      <div className="feature-progress" aria-label={ja?'表示する機能':'Choose a feature'}>{items.map((entry,i)=><button type="button" key={entry.number} onClick={() => go(i)} aria-label={ja?`${i+1}番目の機能: ${entry.title}`:`Feature ${i+1}: ${entry.title}`} aria-current={i===index?'true':undefined} className={i===index?'is-active':''} />)}</div>
    </div>
  );
}
